export const FONT_BRIGHTNESS = Object.freeze({
    DARK: 'DARK',
    LIGHT: 'LIGHT',
});
export const FONT_BRIGHTNESS_MAPPING = Object.freeze({
    asphalt: {
        [FONT_BRIGHTNESS.DARK]: 'asphalt',
        [FONT_BRIGHTNESS.LIGHT]: 'white',
    },
    black: {
        [FONT_BRIGHTNESS.DARK]: 'black',
        [FONT_BRIGHTNESS.LIGHT]: 'snow',
    },
    dove: {
        [FONT_BRIGHTNESS.DARK]: 'dove',
        [FONT_BRIGHTNESS.LIGHT]: 'snow',
    },
});
export const FONT_SIZE_BASE = 13;
export const FONT_SIZE_BASE_ALT = 0.813 * FONT_SIZE_BASE;
//# sourceMappingURL=constants.js.map